import React, { useEffect } from 'react';
import { withStyles, Paper, Grid } from '@material-ui/core';
import ListIcon from '@material-ui/icons/List';
import Call from '@material-ui/icons/Call';
import WhatsApp from '@material-ui/icons/PhoneAndroid';
import Email from '@material-ui/icons/Email';
import Note from '@material-ui/icons/Note';
import Person from '@material-ui/icons/Person';
import { styles } from './styles';
import TasksTabBar from '../tasksTabBar';

const TasksDashboard = (props) => {
  const { classes, activityIndicators, brokers } = props;

  const renderTasks = () => {
    console.log("brokers", brokers)
    return (
      <div className={classes.root2}>
        <TasksTabBar brokers={brokers} />
      </div>
    );
  };

  return (
    <div className={classes.root}>
      <Grid className={classes.heightDashBoard} container spacing={24}>
        <Grid item md={12} xs={12}>
          <Paper className={`${classes.paper} ${classes.cardAdjusted}`}>
            <h5 className={classes.titleCard}> Estas son tus tareas</h5>
            <hr></hr>
            <div>{brokers && brokers.length && renderTasks()}</div>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(TasksDashboard);
